var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title != null)?_c('label',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"select-content"},[_c('select',{staticClass:"form-control",attrs:{"required":_vm.required,"name":_vm.name != null ? _vm.name : ''},domProps:{"value":_vm.valueInput},on:{"input":_vm.update,"change":_vm.change}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }